import { t as _objectSpread2 } from "./objectSpread2-BNmiQYyW.js";

//#region src/constants/keyboardShortcuts.ts
/**
* Default keyboard shortcuts configuration for DocSearch. These values are used
* when no keyboardShortcuts prop is provided or when specific shortcuts are not
* configured.
*/
const DEFAULT_KEYBOARD_SHORTCUTS = {
	"Ctrl/Cmd+K": true,
	"/": true
};
/**
* Merges user-provided keyboard shortcuts with defaults.
*
* @param userShortcuts - Optional user configuration.
* @returns Complete keyboard shortcuts configuration with defaults applied.
*/
function getKeyboardShortcuts(userShortcuts) {
	return _objectSpread2(_objectSpread2({}, DEFAULT_KEYBOARD_SHORTCUTS), userShortcuts);
}

//#endregion
export { getKeyboardShortcuts as t };
//# sourceMappingURL=keyboardShortcuts-C-lx6Xt7.js.map